import React from 'react';
import { CardTotalDebt } from './styled';
import { formatAmount } from '../modules/PayOnline/helpers';

interface TotalDebtProps {
  totalPendingAmount: string;
  description?: string;
}

const TotalDebt = ({
  totalPendingAmount = '0',
  description = 'Total a pagar'
}: TotalDebtProps) => (
  <CardTotalDebt>
    <div className="totalDebt">
      <span>{description}</span>
      <span>S/ {formatAmount(totalPendingAmount)}</span>
    </div>
  </CardTotalDebt>
);

export { TotalDebt };
